import { render, staticRenderFns } from "./DetailOrderModal.vue?vue&type=template&id=279ff217&scoped=true"
import script from "./DetailOrderModal.vue?vue&type=script&lang=ts"
export * from "./DetailOrderModal.vue?vue&type=script&lang=ts"
import style0 from "./DetailOrderModal.vue?vue&type=style&index=0&id=279ff217&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279ff217",
  null
  
)

export default component.exports